import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "../../hooks/useTranslation";

const Root = styled(Card)({
  height: "100%",
  backgroundColor: "white",
  p: 2,
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  position: "relative",
  overflow: "hidden",
});

const SolidLine = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "4%",
  backgroundColor: theme.palette.primary.lighter,
}));

export const OrdersAmountToday = ({ allOrders, onClick }) => {
  const { t } = useTranslation();
  
  if (!allOrders) {
    return;
  }

  const currentDate = new Date();
  const ordersToday = allOrders.filter((order) => {
    const orderDate = new Date(order.createdAt);
    // Check if order is from today (same day, month, and year)
    return orderDate.getDate() === currentDate.getDate() &&
           orderDate.getMonth() === currentDate.getMonth() &&
           orderDate.getFullYear() === currentDate.getFullYear();
  });

  const numberOfOrders = ordersToday.length;

  const content = (
    <CardContent>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={0}
      >
        <Typography
          variant="subtitle1"
          component="p"
          gutterBottom
          sx={{ lineHeight: 2.5 }}
        >
          {t('ordersLast24hrs')}
        </Typography>
        <Typography variant="h4" component="h4">
          {numberOfOrders}
        </Typography>
      </Stack>
    </CardContent>
  );

  return (
    <Root>
      <SolidLine />
      {onClick ? (
        <CardActionArea onClick={onClick} sx={{ height: "100%" }}>
          {content}
        </CardActionArea>
      ) : (
        content
      )}
    </Root>
  );
};